export const breakpoints = {
  mobile: '640px',
  tablet: '720px',
  lgTablet: '960px',
  desktop: '1280px',
  lgDesktop: '1440px',
} as const;
